import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import CreateLeads from "./createleads";
import AddFile from "./addfile";
import ContentAccount from "./createcontent";
import SuccessMail from "./sucessmail";
import Access from "./access";
import AddContent from "./addcontent";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Select from "react-select";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import Table from "../../../core/common/dataTable/index";
import { leadsData } from "../../../core/data/json/leads";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import DefaultEditor from "react-simple-wysiwyg";
import { Modal } from "react-bootstrap";
import {
  accountType,
  ascendingandDecending,
  documentType,
  LocaleData,
  statusList,
} from "../../../core/common/selectoption/selectoption";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import {
  fetchLeadHistory,
  LeadHistoryItem,
  LeadHistoryResponse,
} from "../../../api/leadtimeline";
import { FaPen, FaPlus } from "react-icons/fa";
import { fetchAllLeads, Lead } from "../../../api/lead";
import {
  parseISO,
  isToday,
  isYesterday,
  isThisWeek,
  isThisMonth,
} from "date-fns";
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
const route = all_routes;

interface TimelineItem {
  date: string;
  time: string;
  modified_by: string;
  changes: string;
  type: string;
}

type GroupedHistory = Record<string, TimelineItem[]>;
const LeadsDetails = () => {
  const { lead_id: paramLeadId } = useParams<{ lead_id: string }>();
  const location = useLocation();
  const leadFromState = location.state as Lead | null;

  const leadId = paramLeadId || leadFromState?.lead_id;

  const [leads, setLeads] = useState<Lead[]>([]);

  useEffect(() => {
    const loadLeads = async () => {
      const data = await fetchAllLeads();
      setLeads(data);
    };
    loadLeads();
  }, []);

  const [addcomment, setAddComment] = useState(false);
  const togglecomment = () => {
    setAddComment((prevState) => !prevState);
  };
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    leadsData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };
  const [isEditor3, setIsEditor3] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [isEditor2, setIsEditor2] = useState(false);
  // Call initializeStarsState once when the component mounts
  React.useEffect(() => {
    initializeStarsState();
  }, []);
  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const [openModal, setOpenModal] = useState(false);
  const sortbydata = [
    { value: "Sort By Date", label: "Sort By Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
  ];
  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];
  const statusColors: { [key: string]: string } = {
    "Not Contacted": "bg-warning text-dark",
    Contacted: "bg-success text-white",
    Closed: "bg-info text-white",
    Lost: "bg-danger text-white",
  };
  const statuses = [
    { name: "Not Contacted", className: "bg-warning" },
    { name: "Contacted", className: "bg-success" },
    { name: "Closed", className: "bg-info" },
    { name: "Lost", className: "bg-danger" },
  ];
  const statusClassMap: { [key: string]: string } = {
    "Not Contacted": "bg-warning",
    Contacted: "bg-success",
    Closed: "bg-info",
    Lost: "bg-danger",
  };

  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
  ];

  const [timelineData, setTimelineData] = useState<GroupedHistory>({});
  const [openDates, setOpenDates] = useState<string[]>([]);

  const toggleDate = (group: string) => {
    setOpenDates((prev) =>
      prev.includes(group) ? prev.filter((g) => g !== group) : [...prev, group]
    );
  };

  useEffect(() => {
    const loadTimeline = async () => {
      if (leadId) {
        try {
          const data = await fetchLeadHistory(leadId);
          setTimelineData(prepareLeadTimeline(data));
        } catch (err) {
          console.error("Failed to load lead timeline:", err);
          // Optionally show fallback UI or message
        }
      }
    };
    loadTimeline();
  }, [leadId]);

  const getDateGroupLabel = (date: string): string => {
    const d = new Date(date);

    if (isToday(d)) return "Today";
    if (isYesterday(d)) return "Yesterday";
    if (isThisWeek(d, { weekStartsOn: 1 })) return "This Week";
    if (isThisMonth(d)) return "This Month";

    // fallback to localized full date
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  const prepareLeadTimeline = (data: LeadHistoryResponse): GroupedHistory => {
    const formatItem = (item: LeadHistoryItem, type: string): TimelineItem => {
      const localDate = new Date(item.modified_at);
      const date = localDate.toISOString().split("T")[0];
      const time = localDate.toTimeString().split(" ")[0];

      const changes = Object.entries(item.changed_values)
        .map(([field, value]) => {
          const from = value.old || "-";
          const to = value.new || "-";
          return `<b>${field}</b> was updated from <b>${from}</b> to <b>${to}</b>`;
        })
        .join("<br/>");

      return {
        date,
        time,
        modified_by: item.modified_by,
        changes,
        type,
      };
    };

    const createdAt = new Date(data.lead_created_at);
    const createdEntry: TimelineItem = {
      date: createdAt.toISOString().split("T")[0],
      time: createdAt.toTimeString().split(" ")[0],
      modified_by: "System",
      changes: "<b>Lead</b> was <b>created</b>.",
      type: "created",
    };

    const allItems = [
      ...data.lead_history.map((h) => formatItem(h, "lead")),
      createdEntry, // moved to the end
    ].sort((a, b) => {
      const aDate = new Date(`${a.date}T${a.time}`);
      const bDate = new Date(`${b.date}T${b.time}`);
      return bDate.getTime() - aDate.getTime(); // sort: newest to oldest
    });

    return allItems.reduce((acc, curr) => {
      const group = getDateGroupLabel(curr.date);
      acc[group] = acc[group] || [];
      acc[group].push(curr);
      return acc;
    }, {} as GroupedHistory);
  };

  if (leads.length === 0) return <p>No leads found</p>;

  const lead = leads.find((l) => l.lead_id === leadId) || leadFromState;
  if (!lead) return <p>Lead not found</p>;

  const contact = lead.contact;
  const branch = contact?.branch?.[0];

  // Function to get index of current status
const getStatusIndex = (status: string | undefined | null) => {
  if (!status) return -1;

  return statuses.findIndex(
    (s) =>
      s?.name?.toLowerCase?.().replace(/\s/g, "") ===
      status.toLowerCase().replace(/\s/g, "")
  );
};



  const currentIndex = getStatusIndex(lead.lead_status);

  if (currentIndex === -1) {
    console.warn(`Unknown lead status: ${lead.lead_status}`);
    // Optionally still show the page or a fallback status
  }

  // ✅ Extract unique lead statuses from timeline in order
  const dynamicStatuses: string[] = Array.from(
    new Set(
      Object.values(timelineData)
        .flat()
        .filter((item) => item.changes.includes("lead_status"))
        .map((item) => {
          const match = item.changes.match(
            /<b>lead_status<\/b> was updated from <b>.*<\/b> to <b>(.*)<\/b>/
          );
          return match?.[1]?.trim() || "";
        })
        .filter((status): status is string => !!status)
    )
  );

  // ✅ Fallback if no updates (still show created status)
  if (dynamicStatuses.length === 0 && lead?.lead_status) {
    dynamicStatuses.push(lead.lead_status);
  }

  // ✅ Map dynamic status list to your UI format
  const pipelineStatuses = dynamicStatuses.map((status) => ({
    name: status,
    className: statusClassMap[status] || "bg-secondary",
  }));

  return (
    <>
      <PageLoadProgressBar />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">
                      <i className="ti ti-chart-arcs text-primary me-2" />
                      Leads Overview </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {/* Leads User */}
                <div className="contact-head">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to={route.leads}>
                            <i className="ti ti-arrow-narrow-left" />
                            Leads
                          </Link>
                        </li>
                        <li>{contact?.contact_person_name || "No Name"} </li>
                      </ul>
                    </div>
                    {/* <div className="col-sm-6 text-sm-end">
                      <div className="contact-pagination">
                        <p>1 of 40</p>
                        <ul>
                          <li>
                            <Link to={route.leadsDetails}>
                              <i className="ti ti-chevron-left" />
                            </Link>
                          </li>
                          <li>
                            <Link to={route.leadsDetails}>
                              <i className="ti ti-chevron-right" />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="card">
                  <div className="card-body pb-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar avatar-xxl me-3 flex-shrink-0 border p-2">
                          <h6 className="text-default fw-medium">
                            {contact?.company_name
                              ?.substring(0, 2)
                              .toUpperCase() || "--"}
                          </h6>
                        </div>
                        <div>
                          <h5 className="mb-1">
                            {contact?.contact_person_name || "No Name"}{" "}
                            <span className="star-icon">
                              <i className="fa-solid fa-star" />
                            </span>
                          </h5>
                          <p className="mb-1">
                            <i className="ti ti-building me-1" />
                            {contact?.company_name || "Company not available"}
                          </p>
                          <p className="mb-0">
                            <i className="ti ti-map-pin-pin me-1" />
                            {branch
                              ? `${branch.branch_address}, ${branch.branch_city}, ${branch.branch_country}`
                              : "No branch info"}
                          </p>
                        </div>
                      </div>

                      <div className="contacts-action">
                        {/* <span className="badge badge-light">
                <i className="ti ti-lock" /> Private
              </span> */}
                        <div className="mb-2">
                          <span
                            className={`badge ${
                              statusColors[lead.lead_status] || "bg-secondary"
                            } py-1 px-2`}
                          >
                            {lead.lead_status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body p-3">
                    <h6 className="mb-3 fw-semibold">Lead Information</h6>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Date Created</span>
                        <span className="col-6">
                          {new Date(lead.created_at).toLocaleString()}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Value</span>
                        <span className="col-6">
                          {lead.Currency} {lead.lead_value || "N/A"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Source</span>
                        <span className="col-6">
                          {lead.leadsource?.LeadSource_name || "N/A"}
                        </span>
                      </li>
                    </ul>

                    <h6 className="mb-3 fw-semibold">Owner</h6>
                    <div className="d-flex align-items-center mb-3">
                      <div className="avatar avatar-md me-2">
                        <img
                          src="assets/img/profiles/avatar-21.jpg"
                          alt="Image"
                        />
                      </div>
                      <p>{lead.users?.name || "Unknown"}</p>
                    </div>

                    <hr />
                    {/* <h6 className="mb-3 fw-semibold">Tags</h6>
            <Link to="#" className="badge badge-soft-success fw-medium me-2">
              Collab
            </Link>
            <Link to="#" className="badge badge-soft-warning fw-medium">
              Rated
            </Link> */}

                    <hr />
                    {/* <h6 className="mb-3 fw-semibold">Projects</h6>
            <Link
              to="#"
              className="badge bg-light-300 text-default me-2 mb-2"
            >
              Devops Design
            </Link>
            <Link to="#" className="badge bg-light-300 text-default mb-2">
              Margrate Design
            </Link> */}

                    {/* <hr />
            <h6 className="mb-3 fw-semibold">Priority</h6>
            <div className="priority-info">
              <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
                    High
                  </span>
                  <i className="ti ti-chevron-down me-1" />
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" to="#">
                    <span>
                      <i className="ti ti-square-rounded-filled me-1 text-danger circle" />
                      High
                    </span>
                  </Link>
                  <Link className="dropdown-item" to="#">
                    <span>
                      <i className="ti ti-square-rounded-filled me-1 text-success circle" />
                      Low
                    </span>
                  </Link>
                </div>
              </div>
            </div> */}

                    <hr />
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <h6 className="mb-3 fw-semibold">Contacts</h6>
                      <Link
                        to={route.contactList}
                        className="link-purple mb-3 fw-medium"
                      >
                        <i className="ti ti-circle-plus me-1" />
                        Add New
                      </Link>
                    </div>
                    <div className="d-flex align-items-center mb-0">
                      <div className="avatar avatar-md me-2">
                        <img
                          src="assets/img/profiles/avatar-01.jpg"
                          alt="Image"
                        />
                      </div>
                      <p>{contact?.contact_person_name || "N/A"}</p>
                    </div>

                    <hr />
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Last Modified</span>
                        <span className="col-6">
                          {new Date(lead.updated_at).toLocaleString()}
                        </span>
                      </li>
                      <li className="row mb-0">
                        <span className="col-6">Modified By</span>
                        <span className="col-6">
                          <span className="avatar avatar-xs me-1">
                            <img
                              src="assets/img/profiles/avatar-19.jpg"
                              className="avatar-xs"
                              alt="img"
                            />
                          </span>
                          {lead.users?.name || "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Leads Sidebar */}
              {/* Leads Details */}
              <div className="col-xl-9">
                <div className="card mb-3">
                  <div className="card-body pb-0">
                    <h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>
                    <div className="pipeline-list">
                      <ul className="d-flex list-unstyled gap-3 flex-wrap align-items-center">
                        {pipelineStatuses.map((status) => (
                          <li key={status.name}>
                            <Link
                              to="#"
                              className={`${status.className} px-4 py-2 rounded text-white fw-semibold shadow-sm d-inline-block`}
                              style={{
                                minWidth: "120px",
                                textAlign: "center",
                                userSelect: "none",
                                transition: "background-color 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.filter =
                                  "brightness(1.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.filter = "none";
                              }}
                            >
                              {status.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#activities"
                          className="nav-link active"
                        >
                          <i className="ti ti-alarm-minus me-1" />
                          Activities
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Tab Content */}
                <div className="tab-content pt-0">
                  {/* Activities */}
                  <div className="tab-pane active show" id="activities">
                    <h4 className="fw-3 mb-4">
                      <i className="bi bi-clock-history me-2"></i> Timeline
                      History
                    </h4>
                    {Object.entries(timelineData).map(([group, items], idx) => (
                      <div key={idx} className="mb-3">
                        <Button
                          onClick={() => toggleDate(group)}
                          className="bg-white border-start border-4 rounded-2 shadow-sm mb-2 fw-semibold text-dark px-3 py-2 w-auto d-inline-block text-start"
                        >
                          {group}
                          <span className="float-end">
                            {openDates.includes(group) ? "−" : "+"}
                          </span>
                        </Button>

                        <div
                          className={`collapse ${
                            openDates.includes(group) ? "show" : ""
                          }`}
                          id={`collapse-${group}`}
                        >
                          {items.map((item, i) => {
                            const localDateTime = new Date(
                              `${item.date}T${item.time}`
                            );
                            if (isNaN(localDateTime.getTime())) {
                              console.error(
                                "Invalid date:",
                                item.date,
                                item.time
                              );
                              return null; // skip this entry or fallback rendering
                            }
                            return (
                              <div key={i} className="d-flex mt-3">
                                <div
                                  className="text-nowrap me-3 text-dark fw-semibold"
                                  style={{ width: "70px" }}
                                >
                                  {localDateTime.toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                                <div className="me-3">
                                  <div
                                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                                    style={{ width: 28, height: 28 }}
                                  >
                                    {item.type === "created" ? (
                                      <FaPlus size={12} />
                                    ) : (
                                      <FaPen size={12} />
                                    )}
                                  </div>
                                </div>
                                <div className="bg-white p-3 rounded shadow-sm border w-100">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.changes,
                                    }}
                                  />
                                  <div className="text-muted small mt-1">
                                    by {item.modified_by} on{" "}
                                    {localDateTime.toLocaleDateString(
                                      undefined,
                                      {
                                        weekday: "short",
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                      }
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* /Activities */}
                </div>
                {/* /Tab Content */}
              </div>
              {/* /Leads Details */}
            </div>
          </>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default LeadsDetails;
